// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SimilarStrollers__headline":"xv_a bhu_uj bhu_ua bhu_vx bhu_qk bhu_sl bhu_qb"};